module.exports = __webpack_public_path__ + "img/emptyDetail.1630993415105.png";